import styles from './horizontalRule.module.scss';

const horizontalRule = () => <hr className={styles.horizontalRule} />;

export default horizontalRule;
